/**
 * Shared document-head primitives used by RouteMetadata (static routes) and
 * the officer-page head manager (profileHead.ts) so both write tags the same
 * way and can safely overwrite each other across navigation.
 */

export function upsertMeta(attribute: 'name' | 'property', key: string, content: string) {
  let meta = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, key);
    meta.dataset.lwSeo = 'managed';
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export function removeMeta(attribute: 'name' | 'property', key: string) {
  document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`)?.remove();
}

export function setCanonical(href: string | null) {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!href) {
    link?.remove();
    return;
  }
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    link.dataset.lwSeo = 'managed';
    document.head.appendChild(link);
  }
  link.href = href;
}
